import { mapActions, mapGetters, mapMutations } from "vuex";

export const addNewHomeMixin = {
  computed: {
    ...mapGetters("addNew", {
      loading: "getLoading",
      formSubmitted: "getFormSubmitted"
    }),
    ...mapGetters({
      previousRoute: "getPreviousRoute",
      userRole: "getUserRole"
    })
  },
  methods: {
    ...mapActions("addNew", {
      getTimezones: "getTimezones",
      getInsuranceDetails: "getInsuranceDetails"
    }),
    ...mapMutations("addNew", {
      setFormSubmitted: "setFormSubmitted",
      clearState: "clear"
    })
  },
  created() {
    this.getTimezones();
    // Get insureance details for non portal users
    if (this.userRole !== 22 && this.userRole !== 25) {
      this.getInsuranceDetails();
    }
  },
  watch: {
    formSubmitted(value) {
      if (
        value &&
        (this.$router.history.current.path === "/add_client" ||
          this.$router.history.current.path === "/add_person" ||
          this.$router.history.current.path === "/add_event" ||
          this.$router.history.current.path === "/add_group")
      ) {
        this.setFormSubmitted(false);
        if ("previousRoute" in this && this.previousRoute === "/") {
          this.$router.push("/daily");
          return;
        }
        this.$router.go(-1);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearState(); // Emptying state before route is left
    next();
  }
};
